import { render, staticRenderFns } from "./isDeleteAccount.vue?vue&type=template&id=1165c3e8&scoped=true"
import script from "./isDeleteAccount.vue?vue&type=script&lang=js"
export * from "./isDeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./isDeleteAccount.vue?vue&type=style&index=0&id=1165c3e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165c3e8",
  null
  
)

export default component.exports